import { ThinkingIcon } from "@assets/icon";
import React, { useEffect, useState } from "react";
import "./ChatAdmin.scss";

const DOT_COUNT = 4;
const DOT_INTERVAL_MS = 300;

const ChatThinking: React.FC = () => {

  const [dotCount, setDotCount] = useState(4);

  useEffect(() => {
    const id = window.setInterval(() => {
      setDotCount((n) => {
        if (n === DOT_COUNT) return 0;
        if (n === 0) return 1;
        return n + 1;
      });
    }, DOT_INTERVAL_MS);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div className="chat-admin flex flex-col mt-[10px]">
      <div className="flex items-center mb-2 text-purple-400">
        <ThinkingIcon className="w-5 h-5 animate-pulse" />
        <span className="text-sm text-[var(--colour-primary-neutral-shade-xl)] ml-2">
          Vui lòng chờ trong giây lát
        </span>
        <span
          className="inline-flex text-sm text-[var(--colour-primary-neutral-shade-xl)] ml-2"
          aria-hidden="true"
        >
          {Array.from({ length: DOT_COUNT }, (_, i) => (
            <span
              key={i}
              className={`w-[0.35em] text-center inline-block transition-opacity duration-150 ${
                i < dotCount ? "opacity-100" : "opacity-0"
              }`}
            >
              .
            </span>
          ))}
        </span>
      </div>
    </div>
  );
};

export default ChatThinking;